import { withExperienceNotifier } from '@atlassian/help-center-common-component/analytics';
import RequestCreateForm from './request-create-form';

export default withExperienceNotifier('request-create-form')(RequestCreateForm);
